import React from 'react'
import { Button, Form, Row, Col } from "react-bootstrap"
import Fade from 'react-reveal/Fade';
import tpic from "../imgs/teacher.png"
import spic from "../imgs/graduated.png"
import {Link } from "react-router-dom";
import { Helmet } from 'react-helmet'
const Index = () => {
  return (
    <>
       <Helmet>
          <title>Registration</title>
        </Helmet>
      <div className="bg"></div>
      <div className="bg bg2"></div>
      <div className="bg bg3"></div>
      {/* <div className="content"> */}

      <div className="container1">

        <div className="wrapper1">
          <ul className="steps">
            <li className="is-active">Step 1</li>
          </ul>
          <form className="form-wrapper1">
            <fieldset className="section is-active">
              <h3>Account type</h3>
              <p>Are you a student or a teacher?</p>

              <Row>
                <Col>
                <Link to="/tstep1">
                  <Button style={{marginBottom:"10px"}}><img src={tpic} alt="teacher icon" style={{ height: "200px", width: "150px" }} /> <br /> teacher</Button>
                  </Link>
                </Col>
                <Col>
                <Link to="/Sstep1">
                  <Button><img src={spic}  alt="student icon" style={{ height: "200px", width: "150px" }} />  <br /> student</Button>
                  </Link>
                </Col>
              </Row>
            </fieldset>
          </form>
        </div>
      </div>

      {/* </div> */}
    </>
  )
}

export default Index
